document.addEventListener('click',async(e)=>{
  const b=e.target.closest('[data-xs-add]');if(!b)return;
  e.preventDefault();
  const sel=b.closest('.xs__item').querySelector('.xs__select');
  const id=sel?sel.value:b.dataset.xsAdd;
  b.disabled=true;const t=b.textContent;b.textContent='...';
  try{
    const r=await fetch(window.Shopify&&Shopify.routes?Shopify.routes.root+'cart/add.js':'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}],sections:'cart-icon-bubble'})});
    const d=await r.json();if(!r.ok)throw d;
    if(location.pathname.replace(/\/$/,'').endsWith('/cart')){location.reload();return;}
    b.textContent='Added ✓';
    const bubble=document.getElementById('cart-icon-bubble');
    if(bubble&&d.sections&&d.sections['cart-icon-bubble']){const h=new DOMParser().parseFromString(d.sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section');if(h)bubble.innerHTML=h.innerHTML;}
  }catch(err){b.disabled=false;b.textContent=t;alert((err&&err.description)||'Could not add this item');}
});

// Rotate: shuffle each pool so a different set shows on every visit (pages are cached, so this runs in the browser)
function xsShuffle(root){
  (root.querySelectorAll?root:document).querySelectorAll('.xs[data-xs-show]:not([data-xs-shuffled])').forEach(x=>{
    const ul=x.querySelector('.xs__list');if(!ul)return;
    const items=[...ul.children];
    for(let i=items.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[items[i],items[j]]=[items[j],items[i]];}
    items.forEach(li=>ul.appendChild(li));
    x.setAttribute('data-xs-shuffled','');
  });
}
xsShuffle(document);
new MutationObserver(ms=>{for(const m of ms)for(const n of m.addedNodes)if(n.nodeType===1)xsShuffle(n.parentNode||n);}).observe(document.documentElement,{childList:true,subtree:true});

// Sets offer: toggle the list, add a half-price set, refresh the line
document.addEventListener('click',async(e)=>{
const t=e.target.closest('[data-so-toggle]');
if(t){e.preventDefault();const l=t.closest('[data-so]').querySelector('.so__list');l.hidden=!l.hidden;t.setAttribute('aria-expanded',String(!l.hidden));const lb=t.dataset.label||'sets';t.firstElementChild.textContent=(l.hidden?'View ':'Hide ')+lb;t.lastElementChild.textContent=l.hidden?'▾':'▴';return;}
const b=e.target.closest('[data-so-add]');if(!b)return;
e.preventDefault();
const sel=b.closest('.xs__item').querySelector('.xs__select');
const id=sel?sel.value:b.dataset.soAdd;
const holder=b.closest('#cart-notification-product');const cn=document.querySelector('cart-notification');const key=cn&&cn.cartItemKey;
b.disabled=true;const txt=b.textContent;b.textContent='...';
try{
const secs=holder?'cart-icon-bubble,cart-notification-product,cart-notification-button':'cart-icon-bubble';
const r=await fetch(window.Shopify&&Shopify.routes?Shopify.routes.root+'cart/add.js':'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}],sections:secs})});
const d=await r.json();if(!r.ok)throw d;
if(!holder){location.reload();return;}
if(!key){b.textContent='Added ✓';}
const parse=h=>new DOMParser().parseFromString(h,'text/html');
const s=d.sections||{};
const bubble=document.getElementById('cart-icon-bubble');
if(bubble&&s['cart-icon-bubble']){const h=parse(s['cart-icon-bubble']).querySelector('.shopify-section');if(h)bubble.innerHTML=h.innerHTML;}
let done=false;
if(key&&s['cart-notification-product']){const f=parse(s['cart-notification-product']).querySelector('[id^="cart-notification-product-'+key.split(':')[0]+':"]');if(f){holder.innerHTML=f.innerHTML;done=true;}}
if(!done)b.textContent='Added ✓';
const vb=document.getElementById('cart-notification-button');
if(vb&&s['cart-notification-button']){const f=parse(s['cart-notification-button']).querySelector('.shopify-section');if(f)vb.innerHTML=f.innerHTML;}
}catch(err){b.disabled=false;b.textContent=txt;}
});
// Cart page: refresh the offer line after quantity changes
document.addEventListener('DOMContentLoaded',()=>{
if(typeof subscribe!=='function'||typeof PUB_SUB_EVENTS==='undefined')return;
subscribe(PUB_SUB_EVENTS.cartUpdate,async()=>{
const sec=document.querySelector('.cart-xs');const wrap=sec&&sec.closest('.shopify-section');if(!wrap)return;
const id=wrap.id.replace('shopify-section-','');
try{const j=await fetch(location.pathname+'?sections='+id).then(r=>r.json());const f=new DOMParser().parseFromString(j[id],'text/html').querySelector('.shopify-section');if(f)wrap.innerHTML=f.innerHTML;}catch(e){}
});
});
